import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
    Hide,
    Divider,
    Heading,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon, AddIcon, PlusSquareIcon } from '@chakra-ui/icons';
import { ButtonContainer, StyledHeading } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import CaseStudySection from '../../sections/CaseStudySection/CaseStudySection';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=609727&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - strona subskrypcje',
};

export default function SubscriptionModulePage(props: Props) {
    const howToApplyForLoaAtWealthonItems = [
        {
            svgIcon: (
                <>
                    <svg
                        // height="69"
                        width="14"
                        height="40"
                        viewBox="0 0 14 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0.944 7.6V0.633998H13.958V40H6.182V7.6H0.944Z" fill="#1AAC7A" />
                    </svg>
                </>
            ),
            title: 'Złóż wniosek na wealthon.com',
            text: 'Potrzebujesz zaledwie kilku danych: NIP, nr telefonu oraz adres e-mail.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="28"
                        height="41"
                        viewBox="0 0 28 41"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3.238 32.468C6.694 29.588 9.448 27.194 11.5 25.286C13.552 23.342 15.262 21.326 16.63 19.238C17.998 17.15 18.682 15.098 18.682 13.082C18.682 11.246 18.25 9.806 17.386 8.762C16.522 7.718 15.19 7.196 13.39 7.196C11.59 7.196 10.204 7.808 9.232 9.032C8.26 10.22 7.756 11.858 7.72 13.946H0.376C0.52 9.626 1.798 6.35 4.21 4.118C6.658 1.886 9.754 0.769997 13.498 0.769997C17.602 0.769997 20.752 1.868 22.948 4.064C25.144 6.224 26.242 9.086 26.242 12.65C26.242 15.458 25.486 18.14 23.974 20.696C22.462 23.252 20.734 25.484 18.79 27.392C16.846 29.264 14.308 31.532 11.176 34.196H27.106V40.46H0.43V34.844L3.238 32.468Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Udostępnij historię rachunku',
            text: 'Wealthon poprosi o historię rachunku firmowego z ostatnich 12 miesięcy.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="28"
                        height="42"
                        viewBox="0 0 28 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.97 12.002C1.15 8.402 2.41 5.63 4.75 3.686C7.126 1.706 10.24 0.715997 14.092 0.715997C16.72 0.715997 18.97 1.184 20.842 2.12C22.714 3.02 24.118 4.262 25.054 5.846C26.026 7.394 26.512 9.158 26.512 11.138C26.512 13.406 25.918 15.332 24.73 16.916C23.578 18.464 22.192 19.508 20.572 20.048V20.264C22.66 20.912 24.28 22.064 25.432 23.72C26.62 25.376 27.214 27.5 27.214 30.092C27.214 32.252 26.71 34.178 25.702 35.87C24.73 37.562 23.272 38.894 21.328 39.866C19.42 40.802 17.116 41.27 14.416 41.27C10.348 41.27 7.036 40.244 4.48 38.192C1.924 36.14 0.574 33.116 0.43 29.12H7.774C7.846 30.884 8.44 32.306 9.556 33.386C10.708 34.43 12.274 34.952 14.254 34.952C16.09 34.952 17.494 34.448 18.466 33.44C19.474 32.396 19.978 31.064 19.978 29.444C19.978 27.284 19.294 25.736 17.926 24.8C16.558 23.864 14.434 23.396 11.554 23.396H9.988V17.186H11.554C16.666 17.186 19.222 15.476 19.222 12.056C19.222 10.508 18.754 9.302 17.818 8.438C16.918 7.574 15.604 7.142 13.876 7.142C12.184 7.142 10.87 7.61 9.934 8.546C9.034 9.446 8.512 10.598 8.368 12.002H0.97Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Potwierdź tożsamość',
            text: 'Tożsamość potwierdzisz online, wystarczy klika kliknięć!',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="32"
                        height="39"
                        viewBox="0 0 32 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.538 31.332V25.392L18.196 0.119998H26.998V24.744H31.75V31.332H26.998V39H19.438V31.332H0.538ZM19.924 8.22L8.854 24.744H19.924V8.22Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Zaakceptuj umowę online',
            text: 'Wszystkie formalności, w tym podpisanie umowy, załatwisz online.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="28"
                        height="40"
                        viewBox="0 0 28 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M25.322 7.168H7.826V16.402C8.582 15.466 9.662 14.71 11.066 14.134C12.47 13.522 13.964 13.216 15.548 13.216C18.428 13.216 20.786 13.846 22.622 15.106C24.458 16.366 25.79 17.986 26.618 19.966C27.446 21.91 27.86 23.998 27.86 26.23C27.86 30.37 26.672 33.7 24.296 36.22C21.956 38.74 18.608 40 14.252 40C10.148 40 6.872 38.974 4.424 36.922C1.976 34.87 0.59 32.188 0.266 28.876H7.61C7.934 30.316 8.654 31.468 9.77 32.332C10.922 33.196 12.38 33.628 14.144 33.628C16.268 33.628 17.87 32.962 18.95 31.63C20.03 30.298 20.57 28.534 20.57 26.338C20.57 24.106 20.012 22.414 18.896 21.262C17.816 20.074 16.214 19.48 14.09 19.48C12.578 19.48 11.318 19.858 10.31 20.614C9.302 21.37 8.582 22.378 8.15 23.638H0.914V0.526H25.322V7.168Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Poczekaj na decyzję kredytową',
            text: ' Sama decyzja o przyznaniu pożyczki zapada nawet w 30 minut.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="29"
                        height="42"
                        viewBox="0 0 29 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M20.274 11.462C19.914 9.95 19.284 8.816 18.384 8.06C17.52 7.304 16.26 6.926 14.604 6.926C12.12 6.926 10.284 7.934 9.096 9.95C7.944 11.93 7.35 15.17 7.314 19.67C8.178 18.23 9.438 17.114 11.094 16.322C12.75 15.494 14.55 15.08 16.494 15.08C18.834 15.08 20.904 15.584 22.704 16.592C24.504 17.6 25.908 19.076 26.916 21.02C27.924 22.928 28.428 25.232 28.428 27.932C28.428 30.488 27.906 32.774 26.862 34.79C25.854 36.77 24.36 38.318 22.38 39.434C20.4 40.55 18.042 41.108 15.306 41.108C11.562 41.108 8.61 40.28 6.45 38.624C4.326 36.968 2.832 34.664 1.968 31.712C1.14 28.724 0.726 25.052 0.726 20.696C0.726 14.108 1.86 9.14 4.128 5.792C6.396 2.408 9.978 0.715997 14.874 0.715997C18.654 0.715997 21.588 1.742 23.676 3.794C25.764 5.846 26.97 8.402 27.294 11.462H20.274ZM14.766 21.29C12.858 21.29 11.256 21.848 9.96 22.964C8.664 24.08 8.016 25.7 8.016 27.824C8.016 29.948 8.61 31.622 9.798 32.846C11.022 34.07 12.732 34.682 14.928 34.682C16.872 34.682 18.402 34.088 19.518 32.9C20.67 31.712 21.246 30.11 21.246 28.094C21.246 26.006 20.688 24.35 19.572 23.126C18.492 21.902 16.89 21.29 14.766 21.29Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Sprawdź stan konta',
            text: 'Wypłata środków może nastąpić już tego samego dnia! ',
        },
    ];

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title={<>Sprzedaż subskrypcyjna w IdoSell</>}
                image={heroImage}
                subTitle="Wprowadź jeden z najlepszych modeli sprzedażowych w&nbsp;e&#8209;commerce. Zapewnij swoim klientom wygodę i elastyczność, a sobie - zrównoważony biznes."
                buttons={[
                    {
                        title: 'Rozpocznij sprzedaż subskrypcyjną',
                        href: '#form_section',
                        variant: 'default',
                        target: '_self',
                    },
                ]}
            />
            {/*  */}
            <Flex
                className="homepage containerIdosellPages"
                direction={'column'}
                gap={{
                    base: 16,
                    md: 24,
                }}
                py={{
                    base: 16,
                    md: 24,
                }}
            >
                <TilesSection
                    title={'Subskrypcje dopasowane do Twoich potrzeb'}
                    tiles={[
                        {
                            title: 'Zwiększ współczynnik utrzymania klientów',
                            content:
                                'Dzięki regularniej sprzedaży zatrzymasz klientów w sklepie internetowym, a Twoje przychody wzrosną.',
                        },
                        {
                            title: 'Zyskaj stabilne źródło przychodu',
                            content:
                                'Dzięki informacji o liczbie subskrybcji, łatwiej przewidzisz całkowity obrót w sklepie.',
                        },
                        {
                            title: 'Ciesz się wysoką przewidywalnością',
                            content:
                                'Sprzedaż subskrypcyjna ułatwi Ci zarządzanie stanami magazynowymi i dostępnością towarów.',
                        },
                    ]}
                />

                <Box display={'flex'} flexDirection={'column'} gap={'50px'} position={'relative'}>
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: '50%' }} padding={'30ox'}>
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#1AAC7A'}
                                    mb="30px"
                                >
                                    Zyskaj więcej z modułem subskrypcyjnym
                                </Text>
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Większa liczba zamówień
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Regularne zamówienia pomagają utrzymać większą
                                                liczbę aktywnych klientów
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Stabilna sprzedaż
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Subskrypcje umożliwiają stały przepływ zamówień, co
                                                zapewnia stabilność sprzedaży.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Przewidywalny przychód
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Subskrypcje gwarantują przewidywalny dochód, co
                                                pomaga w lepszym zarządzaniu finansami.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Lojalni klienci
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Moduł subskrypcyjny wspiera budowanie lojalności
                                                klientów, którzy chętnie wracają do sklepu.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Profesjonalny wizerunek
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Oferowanie subskrypcji wzmacnia wizerunek sklepu
                                                jako profesjonalnej platformy, która dba o potrzeby
                                                klientów.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                            </Box>
                            <Box width={{ base: '100%', lg: '50%' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=609731&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=609731&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <SectionWithPlusTick
                    alignItems={'center'}
                    display={'flex'}
                    title="Oferuj wygodne i szybkie zakupy"
                    subtitle="Ułatw swoim klientom zakupy dzięki modelowi subskrypcyjnemu. Zapewnij im wygodę, automatyczne odnawianie zamówień i atrakcyjne rabaty, a sobie – stabilny przychód i lojalność kupujących."
                    flexDirection={'column'}
                    background={'#1AAC7A'}
                    imageResponsive={{
                        base: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=609740&ext=.webp',
                            alt: 'Zdjęcie Pani z założonymi rękami',
                        },
                        md: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=609729&ext=.webp',
                            alt: 'Zdjęcie Pani z założonymi rękami',
                        },
                    }}
                    tickItem={[
                        {
                            title: 'Sprzedawaj za pomocą szybkich i bezpiecznych płatności kartowych IdoPay',
                        },
                        {
                            title: 'Łącz sprzedaż jednorazową i subskrypcyjną w jednym sklepie',
                        },
                        {
                            title: 'Motywuj klientów do subskrypcji atrakcyjnymi rabatami.',
                        },
                    ]}
                />
                <Flex flexDir={{ base: 'column', lg: 'row' }} gap={'30px'} alignItems={'center'}>
                    <Show above="lg">
                        <Image
                            maxW={'370px'}
                            src="https://www.idosell.com/panel/file-gate.php?id=609787&ext=.png"
                            alt="Zdjęcie wyrózniające logo Idopay"
                        ></Image>
                    </Show>
                    <Flex
                        flexDir={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'left'}
                        p={{ base: '35px', md: '0px' }}
                    >
                        <Heading
                            fontWeight={'600'}
                            fontSize={'34px'}
                            lineHeight={'48px'}
                            color={'#171717'}
                            mb="15px"
                            as="h2"
                        >
                            Subskrypcje? To proste!
                        </Heading>
                        <Text color={'#171717'} fontSize={'18px'} mb="45px">
                            Moduł subskrypcji jest wbudowany w panel i gotowy do aktywacji. Żeby z
                            niego skorzystać, ustaw IdoPay jako domyślny system obsługujący
                            płatności kartowe.
                        </Text>
                        <Link
                            href="https://www.idosell.com/pl/idopay/"
                            background={'#171717'}
                            color={'white'}
                            padding={'12px 30px'}
                            fontSize={'16px'}
                            fontWeight={'600'}
                            display={'flex'}
                            alignItems={'center'}
                            gap={'10px'}
                            _hover={{
                                underline: 'none',
                                background: 'rgba(11, 113, 83, 0.5)',
                            }}
                        >
                            Włącz IdoPay
                            <svg
                                width="9"
                                height="14"
                                viewBox="0 0 9 14"
                                fill="white"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                            </svg>
                        </Link>
                    </Flex>
                    <Show below="lg">
                        <Image
                            maxW={'200px'}
                            margin={'0 auto'}
                            src="https://www.idosell.com/panel/file-gate.php?id=609724&ext=.png"
                            alt="Zdjęcie wyrózniające logo Idopay"
                        ></Image>
                    </Show>
                </Flex>
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                    position={'relative'}
                    id="form_section"
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: 'calc(100% + 8rem)',
                            top: '-4rem',
                            width: '100vw',
                            left: '-50vw',
                            marginLeft: '50%',
                            zIndex: -2,
                            backgroundColor: 'rgba(238, 238, 238, 1)',
                        },
                        md: {
                            height: 'calc(100% + 10rem) !important',
                            top: '-5rem !important',
                        },
                        lg: {
                            display: 'none',
                        },
                    }}
                >
                    <FormSection
                        sectionTitle="Rozpocznij sprzedaż subskrypcyjną"
                        sectionSubtitle="Zyskaj lojalnych klientów dzięki modułowi subskrypcji w IdoSell."
                        region="eu1"
                        portalId="26134891"
                        formId="f8d62d58-79f1-44be-8ee2-7e389abcd91d"
                    />
                </Box>
                <ContactSection />
            </Flex>
        </ThemeProvider>
    );
}
